// Module
var code = "<div class=\"\" ng-controller=\"LogoutCtrl\"> <div class=\"jumbotron text-center dv\" ng-class=\"dv\"> <h3 style=\"padding-bottom:100px\">{{message}}</h3> </div> </div> ";
// Exports
export default code;